module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectel-uploader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileLink),
      expression: "fileLink"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Place link to selectel"
    },
    domProps: {
      "value": (_vm.fileLink)
    },
    on: {
      "blur": _vm.checkLink,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileLink = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "file-uploader__folder"
  }, [_c('i', {
    staticClass: "fa fa-folder-open",
    on: {
      "click": function($event) {
        _vm.showSelectelList = !_vm.showSelectelList
      }
    }
  }), _vm._v(" "), (_vm.showSelectelList) ? _c('div', {
    staticClass: "file-uploader__list-popup spinner-parent"
  }, [(_vm.selectelLoading) ? _c('spinner', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }) : _c('div', {
    staticClass: "file-uploader__list"
  }, [(_vm.selectelList) ? _c('ul', [_vm._l((_vm.selectelList.folders), function(folder, name) {
    return _c('FileUploaderFolder', {
      key: name,
      attrs: {
        "name": name,
        "content": folder
      },
      on: {
        "attach-file": _vm.attachFile
      }
    })
  }), _vm._v(" "), _vm._l((_vm.selectelList.files), function(file) {
    return _c('File', {
      key: file.basename,
      on: {
        "attach-file": _vm.attachFile
      }
    })
  })], 2) : _c('div', [_vm._v("Container is empty")])])], 1) : _vm._e()]), _vm._v(" "), (_vm.fileLink && _vm.linkStatus) ? _c('div', {
    staticClass: "file-uploader__check"
  }, [(_vm.linkStatus === 'loading') ? _c('div', {
    staticClass: "check-status check-loader",
    attrs: {
      "title": "Link is checking..."
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.linkStatus === 'ok') ? _c('div', {
    staticClass: "check-status check-ok",
    attrs: {
      "title": "Link is correct"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : _vm._e(), _vm._v(" "), (_vm.linkStatus === 'error') ? _c('div', {
    staticClass: "check-status check-error",
    attrs: {
      "title": "Link is incorrect"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d49da1dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/FileUploader/SelectelUploader.vue
// module id = 992
// module chunks = 0